import { apiGenericDelete, apiGenericGet, apiGenericPost } from '@/service';
import { getApiUrl } from '@/util';
import { TTFontDTO, TTFontWithFileDTO } from '@/model';
import { DeleteResponse, SaveResponse } from '@/type';

const BASE_URL = '/api/v1/ttfont/';

export const listTtFontAPI = (): Promise<TTFontDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'list'));

export const listTtFontWithFileAPI = (): Promise<TTFontWithFileDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, 'listWithFile'));

export const loadTtFontAPI = (id: number): Promise<TTFontDTO> =>
  apiGenericGet(getApiUrl(BASE_URL, `load/${id}`));

export const saveTtFontAPI = (request: TTFontDTO): SaveResponse =>
  apiGenericPost(getApiUrl(BASE_URL, `save`), request);

export const deleteTtFontAPI = (id: number): DeleteResponse =>
  apiGenericDelete(getApiUrl(BASE_URL, `remove`), 'id', id);
